import React from 'react';
var ExpandCollapse = function (props) {
    var _a = props.fullWidth, fullWidth = _a === void 0 ? 'none' : _a, _b = props.swapped, swapped = _b === void 0 ? false : _b, leftColumnSlot = props.leftColumnSlot, rightColumnSlot = props.rightColumnSlot, className = props.className;
    var getColumnClass = function (position) {
        return fullWidth === position ? 'col-md-12' : 'col-md-6';
    };
    return (React.createElement("div", { className: "row" + (className ? " " + className : '') },
        fullWidth !== 'right' && (React.createElement("div", { className: getColumnClass('left') }, swapped ? rightColumnSlot : leftColumnSlot)),
        fullWidth !== 'left' && (React.createElement("div", { className: getColumnClass('right') }, swapped ? leftColumnSlot : rightColumnSlot))));
};
export default React.memo(ExpandCollapse);
